import React from 'react';
export function Contact() {
  return <section id="contacto" className="py-[100px] px-[5%] relative z-10 bg-dark text-center" data-id="element-11">
      <div className="max-w-[680px] mx-auto" data-id="element-12">
        <div className="text-[0.7rem] tracking-[4px] uppercase text-neon-pink mb-3 text-center" data-id="element-13">
          — ¿Listo?
        </div>
        <h2 className="font-bebas text-[clamp(2.8rem,7vw,5.5rem)] leading-none mb-4" data-id="element-14">
          TU ESPACIO
          <br data-id="element-15" />
          <span className="text-gradient-pink-blue-2" data-id="element-16">MERECE BRILLAR</span>
        </h2>
        <p className="text-text-muted text-base leading-[1.7] my-6 mx-auto max-w-[480px]" data-id="element-17">
          Escribinos ahora, contanos tu idea y en menos de 24hs te mandamos un
          presupuesto sin compromiso. Totalmente personalizado para vos.
        </p>
        <a href="https://wa.me/TUNUMERO?text=Hola!%20Quiero%20pedir%20un%20presupuesto%20personalizado%20para%20un%20cuadro%20con%20ne%C3%B3n%20🔥" target="_blank" rel="noreferrer" className="inline-block bg-gradient-to-br from-neon-pink to-neon-purple text-white px-12 py-5 rounded-md font-bold text-base tracking-[1px] uppercase shadow-[0_0_30px_rgba(255,45,120,0.4)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_50px_rgba(255,45,120,0.6)]" data-id="element-18">
          💬 PEDIR MI PRESUPUESTO AHORA
        </a>
        <p className="text-text-muted text-[0.75rem] mt-5 tracking-[1px]" data-id="element-19">
          Sin compromiso · Respuesta en menos de 24hs · Diseño incluido gratis
        </p>
      </div>
    </section>;
}